import React from 'react';
import { useEffect } from 'react';
import EmailPerformanceEmptyScreen from './EmailPerformanceEmptyScreen';
import EmailPerformanceReadOnly from './EmailPerformanceReadOnly';
import { useParams } from 'react-router-dom';
import { useEmailState } from 'components/EmailStateProvider';
import useEmailDomainFunctions from 'components/Dashboard/hooks/useEmailDomainFunctions';

function EmailPerformance() {
  const params = useParams();
  const { crmEmailId } = params;
  const { emailState } = useEmailState();
  const { emailPerformanceOnLoad } = emailState;
  const { needsDomainVerification } = useEmailDomainFunctions();

  useEffect(() => {
    let title = `Email performance - Influence - PolicyMogul`;
    document.title = title;
  }, []);

  return (
    <div className='engagement-statistics-influence-section main-content pr-xl-5 px-md-4 px-3 h-100'>
      {crmEmailId || (emailPerformanceOnLoad && !needsDomainVerification) ? (
        <div className='h-100' style={{ marginTop: '-42px' }}>
          <EmailPerformanceReadOnly key={crmEmailId} />
        </div>
      ) : (
        <EmailPerformanceEmptyScreen />
      )}
    </div>
  );
}

export default EmailPerformance;
